import { NgModule, Injector } from '@angular/core';
import { KxSharedModule } from '../kx-shared/kx-shared.module';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ChatBotRoutingModule } from './chatbot-routing.module';
import { AppService } from '../base/shared/services/app.service';
import { LaunchbotComponent } from './components/launchbot/launchbot.component';

@NgModule({
  declarations: [
    LaunchbotComponent
  ],
  imports: [
    KxSharedModule,
    ChatBotRoutingModule,
    FormsModule,
    CommonModule,
  ],
  providers: [
  ]
  
})
export class ChatBotModule {
  public entryComponents: any = [
    LaunchbotComponent
  ]

  public appService: AppService;
  constructor(public injector: Injector){
    this.appService = injector.get(AppService);
    this.appService._factories["modules"]["ChatBotModule"] = this.entryComponents;
    if( this.entryComponents &&  this.entryComponents.length){
      this.appService.buildFactory(this.entryComponents);
    }
  }
}
